<!--
 * @Author: your name
 * @Date: 2021-06-25 11:31:56
 * @LastEditTime: 2021-06-29 16:04:18
 * @LastEditors: your name
 * @Description: yang
 * @FilePath: \web_bank\src\views\bind.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="bind">
    <div style="width:55%;margin:0 auto;margin-top:4rem;">
      <div style="width:100%;margin:0 auto;text-align:center;">
        <van-image
          width="141px"
          height="141px"
          fit="contain"
          :src="require('./img/qz.png')" rel="external nofollow" 
        />
      </div>
    </div>
     <div style="margin-top:8rem;">
        <van-divider :style="{ color: '#333333', borderColor: '#CFCECE', padding: '0 24px' }" style="font-size:18px;">
          推荐登录方式
        </van-divider>
      </div>
      <div style="width:75%;margin:0 auto;margin-top:3rem;">
         <van-button type="primary" round  size="large" style="margin-bottom:1rem;" @click="toAntomatic()">一键绑定</van-button>
        <van-button type="default" round  size="large" @click="toManual()">手机验证码登录</van-button>
      </div>
      <van-popup
        v-model="show"
        position="bottom"
        round
        :style="{ height: '40%' }"
      >
      <div class="father">
        <div class="tan">
          <div>
          <van-image
              round
              width="2.5rem"
              height="2.5rem"
              fit="cover"
              :src="require('./img/log.png')" rel="external nofollow"
            />
          </div>
          <div style="margin-left:0.4rem;font-size:1.275rem;font-weight: 500;">轻舟校园</div>
        </div>
        <div class="tan1" style="font-size: 1.1rem;margin-bottom:0.5rem;">
          您的手机号码
        </div>
        <div>
          <van-radio-group v-model="radio">
            <van-cell-group>
              <van-cell title="单选框 1" clickable @click="radio = '1'">
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
              <van-cell title="单选框 2" clickable @click="radio = '2'">
                <template #right-icon>
                  <van-radio name="2" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <div class="tan1 bott">
          <van-button color="#CCCCCC" style="margin-right:2rem;width:25%;" @click="jujue()">拒绝</van-button>
          <van-button type="primary" style="width:25%;">允许</van-button>
        </div>
      </div>
      
      </van-popup>
  </div>
</template>

<script>
import {} from '@/api/http'
export default {
  name: 'bind',
  components: {
   
  },
  data(){
    return{
      show:false,
      radio:"1"
    }
  },
  methods:{
    toManual(){
        //跳转手动绑定页面
        this.$router.push('/manualBind')
    },
    toAntomatic(){
        //跳转自动绑定页面
        // this.$router.push('/antomaticBind')
        this.show = true;
    },
    jujue(){
      this.show = false;
    },
    // show(){

    // }
  },
  mounted(){
    let url = window.location.href;
    console.log(url)

  }
}
</script>
<style scoped>
    .bind{
        width: 100%;
        height: 100%; 
    }
    .tan{
      padding:1rem 1rem;
      display: flex;
      align-items:center;
    }
    .tan1{
        padding:0rem 1rem;
    }
    .bott{
      position: absolute;
      bottom:0.5rem;
      width: 100%;
      display: flex;
      justify-content:center;
    }
    .father{
      height:100%;
      position: relative;
    }
</style>